import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "money-graph",
  "use": "money-graph-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"money-graph\">\n  \n<g transform=\"matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)\"><g>\n    <polyline points=\"0.5 0.5 0.5 13.5 13.5 13.5\" style=\"fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round\" />\n    <polyline points=\"3.5 6.5 6 9 10 3 13.5 5.5\" style=\"fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round\" />\n  </g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol